import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'logout-callback',
  template: `
    <div class="logout-callback">
      <h1>Sessão encerrada</h1>
      <p>Você saiu do Connect.</p>
      <button type="button" (click)="login()">Entrar novamente</button>
    </div>
  `,
  styles: [`
    .logout-callback {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      color: #1f2933;
      text-align: center;
      padding: 24px;
    }

    .logout-callback h1 {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .logout-callback p {
      margin: 0;
      color: #52606d;
      font-size: 14px;
    }

    .logout-callback button {
      min-height: 40px;
      padding: 0 18px;
      border: 0;
      border-radius: 4px;
      background: #1f6feb;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
    }
  `]
})
export class LogoutCallbackComponent implements OnInit {
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.completeLogout();
  }

  login() {
    this.authService.login('/projects');
  }
}
